import { useQuery } from 'react-query';
import { Organization } from '../../entities/Organization';
import { OrganizationService } from '../../services/v1/OrganizationService';

const useCurrentOrganization = (expand: string[]) =>
  useQuery<Organization>(['organizations', 'current'], async () => {
    return await OrganizationService.current({ expand });
  });

export default useCurrentOrganization;
